import { format_price } from "../../utils/cart-utils";

////////////////////
// Template
////////////////////
const template = /*html*/ `
    <div class="c-cart-total">
        <div class="c-cart-total_inner">
            <div class="c-cart-total_inner_container">
                <p class="c-cart-total_hint">
                    <slot name="hint"></slot>
                </p>
                <div class="c-cart-total_recap">
                    <p v-if="showDiscount || showTaxes" class="c-cart-total_recap_item">
                        <span>{{ subtotalLabel }} : </span>
                        <span class="c-cart-total_price_original">{{ currentSubtotal }}</span>
                    </p>
                    <p v-if="showDiscount" class="c-cart-total_recap_item">
                        <span>{{ discountLabel }} : </span>
                        <span>{{ currentSale }}</span>
                    </p>
                    <p v-if="showTaxes" class="c-cart-total_recap_item">
                        <span>{{ taxesLabel }} : </span>
                        <span>{{ currentTaxes }}</span>
                    </p>
                    <p class="c-cart-total_recap_item -total">
                        <span>{{ totalLabel }} : </span>
                        <span>{{ currentTotal }}</span>
                    </p>
                </div>
            </div>
            <form class="c-cart-total_form" @submit="onSubmit" ref="form" method="post" :action="getCartEndpoint">
                <button class="c-button -invert -fluid" type="submit" name="checkout" :disabled="!isCheckoutAvailable">
                    <span class="c-button_label">
                        <slot name="checkout-label"></slot>
                    </span>
                </button>
            </form>
        </div>
    </div>
`;


////////////////////
// Scripts
////////////////////
export default function VueCartTotal(moduleInstance) {

    Vue.component("cart-total", {

        template,

        props: {
            currencyIsoCode: {
                type: String,
                required: true
            },
            currencySymbol: {
                type: String,
                required: true
            },
            subtotalLabel: {
                type: String,
                required: true
            },
            taxesLabel: {
                type: String,
                required: true
            },
            discountLabel: {
                type: String,
                required: true
            },
            totalLabel: {
                type: String,
                required: true
            },
            cartEndpoint: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                isCheckoutAvailable: false,
                total: {
                    amount: '',
                    currencyCode: ''
                },
                subtotal: {
                    amount: '',
                    currencyCode: ''
                },
                taxes: {
                    amount: '',
                    currencyCode: ''
                },
            };
        },

        computed: {
            currentTotal() {
                const total = this.total
                return format_price((parseFloat(total, 10)), this.currencySymbol, this.currencyIsoCode)
            },

            currentSubtotal() {
                const subtotal = this.subtotal
                return format_price((parseFloat(subtotal, 10)), this.currencySymbol, this.currencyIsoCode)
            },

            currentTaxes() {
                const taxes = this.taxes.amount ? this.taxes.amount : 0
                return format_price((parseFloat(taxes, 10) * 100), this.currencySymbol, this.currencyIsoCode)
            },

            currentSale() {
                return this.showDiscount ? `-${100 - Math.round(this.total.amount / this.subtotal.amount * 100)}%` : ''
            },

            showDiscount() {
                return (parseFloat(this.total.amount, 10) * 100) < (parseFloat(this.subtotal.amount, 10) * 100)
            },

            showTaxes() {
                return false
            },

            getCartEndpoint() {
                return this.cartEndpoint
            }
        },

        mounted() {},

        methods: {
            setCheckoutAvailability(state) {
                this.isCheckoutAvailable = state
            },

            setTotalData(cart) {
                this.total = cart.total_price
                this.subtotal = cart.original_total_price
                this.taxes = { amount: '', currencyCode: ''}
            },

            onSubmit(e) {
                // e.preventDefault();

                // if (!this.isCheckoutAvailable && !this.$refs?.form) return

                // form.submit();
            }
        }
    });
}
